<div class="main-layout-wrapper">
    <div class="left-section" [class.show]="storageService.showSidebar()">
        <div class="sidebar-section">
            <app-sidebar></app-sidebar>
        </div>
    </div>
    <div class="right-section scrollbar-8">
        <div class="menu-icon" (click)="handleShowSidebar()">
            <app-icon path="assets/images/common/menubar-icon.svg" />
        </div>
        <div class="router-outlet" (click)="handleHideSidebar()">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>